import stores from 'bootstrap/store';

import notifications from 'bootstrap/notifications';

import { notificationsPaneRouteStore } from '../../../../app/root/routes/app-frame/views/notifications-pane/domain/store';

import { EVENT } from '../../constants';
import { NOTIFICATION_TYPE } from '../../../../app/root/routes/app-frame/views/notifications-pane/constants';


export default ({ apiWebSocket }) => {
  const prescriptionFillsStore = stores.global.prescriptionFills;

  apiWebSocket.on(EVENT.RECEIVED.PRESCRIPTION_FILL_MAIL_ORDERS_CREATE, ({ firstName, lastName, drugName }) => {
    return prescriptionFillsStore.listMailOrderedForNotificationsPane()
    .then(() => {
      notifications.create(`New Mail Order Request for ${drugName}: ${firstName} ${lastName}.`, {
        onClickCallback: () => {
          if (notificationsPaneRouteStore.activeTab !== NOTIFICATION_TYPE.MAIL_ORDERED_PRESCRIPTIONS) {
            notificationsPaneRouteStore.setActiveTab(NOTIFICATION_TYPE.MAIL_ORDERED_PRESCRIPTIONS);
          }
        },
      });
    });
  });
};
